<div class="h-full overflow-hidden">
  <p-scroll-panel class="h-full">
    <form [formGroup]="form">
      <div class="control">
        <label>CPR nummer</label>
        <app-let-input-cpr formControlName="cprNr" />
      </div>
      <div class="control">
        <label>Letsikring nummer</label>
        <input pInputText formControlName="letsikringNr" />
      </div>
      <div class="control">
        <label>PFA Police nummer</label>
        <input pInputText formControlName="pfaPoliceNr" />
      </div>
      <div class="flex gap-2">
        <p-button
          label="Søg"
          (click)="onClickSearch()"
          [loading]="letregisterService.letsikringDatasource.isLoading()"
          icon="pi pi-search"
          type="submit" />
        <p-button
          label="Nulstil"
          (click)="onClickReset()"
          icon="pi pi-times"
          severity="secondary"
          outlined />
      </div>
    </form>
    @if (noHits()) {
      <p-message text="Ingen hits" severity="error" styleClass="mt-4" />
    }
    @if (kunder().length > 1) {
      <div class="font-bold mt-6">
        Der blev fundet flere kunder med det valgte CPR-nummer
      </div>
      <p-table
        [value]="kunder()"
        [showGridlines]="true"
        stripedRows
        class="p-datatable-sm lp-table"
        selectionMode="single"
        [metaKeySelection]="true"
        (onRowSelect)="onKundeSelect($event)">
        <ng-template pTemplate="header">
          <tr>
            <th>Navn</th>
            <th style="width: 140px">CPR nummer</th>
            <th style="width: 120px">Regnr</th>
            <th>Pengeinstitut</th>
          </tr>
        </ng-template>
        <ng-template [appTableRow]="kunder()" pTemplate="body" let-item>
          <tr [pSelectableRow]="item" class="cursor-pointer">
            <td>{{ item.navn }}</td>
            <td>{{ item.cprNummer | cprNummer }}</td>
            <td>{{ item.pengeinstitut?.regnr }}</td>
            <td>{{ item.pengeinstitut?.navn }}</td>
          </tr>
        </ng-template>
      </p-table>
    }
  </p-scroll-panel>
</div>
